<section>
    <div class="page-title">
        <h2>{{ pageData.title }}</h2>
    </div>
    <div class="main-subtitle">
        {{ pageData.subtitle }}
    </div>
    <p class="gtp-header">
        {{ gtpContent.header }}
    </p>
    <p class="gtp-description">
        {{ gtpContent.description }}
    </p>
    <div class="button-group">
        <button class="xm-btn-secondary-light left-btn" *ngIf="gtpContent.primaryButton" (click)="launchGtpFlow()">
            {{ gtpContent.primaryButton }}
        </button>
        <button class="xm-btn-link-light" (click)="onSecondaryBtnClick()">
            {{ gtpContent.secondaryButton }}
        </button>
    </div>
    <div class="gtp-card">
        <xm-media-image aria-hidden="true" [imageOptions]="gtpImage" size="auto"></xm-media-image>
        <div class="card-details">
            <div class="subtitle">{{ pageData.cardTitle }}</div>
            <span class="display-price">{{ pageData.gtpPassPrice }}</span>
            <p class="card-description">
                {{ gtpContent.cardDescription }}
            </p>
        </div>
        <div class="icon-wrapper" role="status" [attr.aria-label]="pageData.cardTitle + ' is ' + gtpContent.statusBadge">
            <xm-media-image *ngIf="showActiveIcon" [imageOptions]="inUseIcon" class="use-icon"></xm-media-image>
            <span class="status" [ngClass]="{ 'status-icon': showActiveIcon }" >
                {{ gtpContent.statusBadge }}
            </span>
        </div>
        <button (click)="launchGtpFlow()" class="xm-btn-secondary-light card-btn">
            {{ gtpContent.cardButton }}
        </button>
    </div>
    <div class="feature-set" *ngIf="gtpFeatures">
        <div class="support-header">
            {{ pageData.featuresTitle }}
        </div>
        <div *ngFor="let feature of gtpFeatures">
            <div class="feature">
                <xm-media-image aria-hidden="true" [imageOptions]="feature.icon" class="feature-icon"></xm-media-image>
                <cms-text class="feature-header"[originalText]="!isBusinessUser ? feature.header : (feature.cbmheader ? feature.cbmheader : feature.header)"></cms-text>
            </div>
        </div>
    </div>
    <div class="support-header">
        {{ pageData.supportHeader }}
    </div>
    <div class="support-links" *ngFor="let supportLink of pageData.supportLinks">
        <xm-decorated-text class="xm-btn-link-light" [ngClass]="{ 'support-modal' :supportLink.isModal }" [inputString]="supportLink.link" (click)="launchPayAsYouGoModal(supportLink)"></xm-decorated-text>
    </div>
</section>
